import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-nosotros',
    templateUrl: './nosotros.component.html',
    styleUrls: ['./nosotros.component.css'],
    standalone: false
})
export class NosotrosComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private seo: SeoService
  ) {
    if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
   }

  ngOnInit(): void {
    this.seo.update({
      title: 'Quienes somos | Clave Winds',
      description: 'Conoce Clave Winds, tienda especializada en instrumentos musicales de viento, accesorios y servicio para musicos.',
      canonical: this.seo.absoluteUrl('/nosotros')
    });
  }

}
